import * as React from "react";
const SvgFiRrJavascript = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-javascript_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h8.515a6.95 6.95 0 0 0 4.95-2.051l3.486-3.484a6.96 6.96 0 0 0 2.05-4.95V5c0-2.757-2.244-5-5.001-5M5 22c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v8.515c0 .165-.032.323-.047.485H17c-1.654 0-3 1.346-3 3v4.953c-.162.016-.32.047-.485.047zm12.05-1.465a5 5 0 0 1-1.05.781V17c0-.552.449-1 1-1h4.316a5 5 0 0 1-.781 1.051zm-.915-9.996 1.229-4.882a.824.824 0 0 1 1.606.033l1.017 4.875a.636.636 0 0 1-.623.767h-.012a.636.636 0 0 1-.623-.507l-.612-2.937-.745 2.963a.638.638 0 0 1-1.236-.31zM7 5.65v3.356a2.07 2.07 0 0 1-2.079 2.063c-.805-.006-1.504-.491-1.849-1.171a.653.653 0 0 1 .578-.952c.249 0 .469.145.583.366.133.257.394.454.687.459a.77.77 0 0 0 .778-.781V5.65a.65.65 0 0 1 1.301.001zm6.978 5.647a.824.824 0 0 1-.799-.623L11.95 5.792a.637.637 0 1 1 1.236-.31l.745 2.963.612-2.937a.64.64 0 0 1 .623-.507h.012c.404 0 .706.371.623.767l-1.017 4.875a.824.824 0 0 1-.807.656zm-3.392-5.641 1.017 4.875a.636.636 0 0 1-.623.767h-.012a.636.636 0 0 1-.623-.507l-.612-2.937-.745 2.963a.637.637 0 0 1-1.236-.311l1.229-4.882a.824.824 0 0 1 1.606.033z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-javascript_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrJavascript;
